import { FC, useState } from 'react'
import Card from 'shared/Cards/Card'
import Grade from 'shared/Grade'
import { IGrade, ITeamResult } from 'screens/Protection/protection.types'
import TextField from 'shared/Forms/TextField'
import AppealModal from '../AppealModal/AppealModal'
import { protectionStatus } from '../../constant/protectionStatus'
import TrashButton from 'shared/Buttons/TrashButton'
import { useRecoilValue } from 'recoil'
import authAtom from 'screens/Auth/auth.atom'

type ProtectionInfoCardProps = {
  teamResult: ITeamResult | null
  onDeleteReview: (id: IGrade['id']) => void
}
const ProtectionInfoCard: FC<ProtectionInfoCardProps> = ({ teamResult, onDeleteReview }: ProtectionInfoCardProps) => {
  const isAdmin = useRecoilValue(authAtom).user.isAdmin
  const [isAppealModalOpen, setIsAppealModalOpen] = useState<boolean>(false)

  const expertsMap =
    teamResult?.scores?.reduce((acc, s) => {
      if (!acc[s.expertId]) {
        acc[s.expertId] = []
      }
      acc[s.expertId].push(s)
      return acc
    }, {} as Record<number, typeof teamResult.scores>) ?? {}

  return (
    <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
      <Card type='normal' style={{ flex: 1 }}>
        <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-start', width: '100%' }}>
          <div className='flex-lines' style={{ flex: 1, minWidth: 0 }}>
            <TextField header='Команда'>{teamResult?.team?.name ?? '—'}</TextField>
            <TextField header='Комната'>{teamResult?.room?.name ?? '—'}</TextField>
            <TextField header='Статус'>{protectionStatus(teamResult?.status) ?? '—'}</TextField>
            <TextField
              header='Ссылка на встречу'
              type='link'
              link={teamResult?.room?.link ?? undefined}
              contentStyle={{ maxWidth: 'max-content' }}
            >
              {teamResult?.room?.link ?? '—'}
            </TextField>
            <div style={{ marginTop: 16, width: '100%' }}>
              {Object.entries(expertsMap).map(([expertId, scores]) => (
                <div key={expertId} style={{ marginBottom: 16 }}>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 430px))',
                      gap: '12px',
                    }}
                  >
                    {scores.map((s) => {
                      const criterion = teamResult?.criteria.find((c) => c.id === s.criterionId)

                      return (
                        <div key={`${s.expertId}-${s.criterionId}`} style={{ position: 'relative' }}>
                          <TextField header={`${s.expert?.info?.name}`} contentStyle={{ maxWidth: 'max-content' }}>
                            <div>
                              <div>
                                {criterion?.name} - {s.score}
                              </div>
                              <p style={{ fontSize: '12px', marginTop: '4px' }}>
                                {s.comment ?? 'Комментарий не указан'}
                              </p>
                            </div>
                          </TextField>
                          {isAdmin && (
                            <div style={{ position: 'absolute', top: '0px', right: '0px' }}>
                              <TrashButton onClick={() => onDeleteReview(s.id)} />
                            </div>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', gap: '18px', flexDirection: 'column', alignItems: 'end' }}>
            <Grade grade={teamResult?.totalScore ?? 0} />
          </div>
        </div>
      </Card>

      {isAppealModalOpen && <AppealModal onClose={() => setIsAppealModalOpen(false)} />}
    </div>
  )
}

export default ProtectionInfoCard
